export default __webpack_public_path__ + "static/media/solution.2d2d7a44.png";